import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/sushiContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-charcoal-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-101" data-mp="1bmllx5jgptjf">
      <div className="mx-auto max-w-2xl px-5" data-id="element-102" data-mp="1gjvid559r5gr">
        <h2 id="faq-title" className="text-center font-display text-2xl font-semibold uppercase leading-tight text-ivory-50 sm:text-4xl" data-id="element-103" data-mp="248o8gkz7mj3g">
          Preguntas frecuentes
        </h2>

        <ul className="mt-9 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-104" data-mp="1uk6aebibeq3i">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-105" data-mp="2n7ikvnb7b7gg" data-mpi={i}>
                <h3 data-id="element-106" data-mp="2n6hc5phnqx1w">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-4 text-left" data-id="element-107" data-mp="2n5z6k293v6hb">
                    <span className="font-display text-lg leading-snug text-ivory-50 sm:text-xl" data-id="element-108" data-mp="1eln4kdam3wjl">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-champagne transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-109" data-mp="19sahw8phtzth" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-110" data-mp="1sm693afvckh0">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-111" data-mp="35584d70ltwy">
                      <p className="pb-5 text-[14px] leading-relaxed text-body" data-id="element-112" data-mp="2867vzud5fpgl">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}